// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"6f2aca4d","769":"65d2d2fd"}[chunkId] + ".chunk.js";
};